import { useState } from 'react';
import { deleteBellSchedule, type BellSchedule } from 'services/api';

interface UseBellScheduleDeleteProps {
  bellSchedule: BellSchedule;
  refreshTable: () => void;
}

export const useBellScheduleDelete = ({
  bellSchedule,
  refreshTable,
}: UseBellScheduleDeleteProps) => {
  const [modalVisible, setModalVisible] = useState(false);

  const showModal = () => {
    setModalVisible(true);
  };

  const hideModal = () => {
    setModalVisible(false);
  };

  const onSubmit = async () => {
    await deleteBellSchedule(bellSchedule.id).then(() => {
      hideModal();
      refreshTable();
    });
  };

  return {
    state: {
      modalVisible,
    },
    methods: {
      showModal,
      hideModal,
      onSubmit,
    },
  };
};
